export default __webpack_public_path__ + "static/media/dropdown_builder.3e82d64f.svg";